<div
  class="cb-chip"
  [ngClass]="[
    'cb-color-' + currentColor,
    'cb-rounded-' + rounded(),
    'cb-type-' + type(),
    'cb-size-' + size(),
    'cb-icon-position-' + iconPosition(),
    'cb-icon-' + iconType(),
  ]"
  [class.cb-clickable]="clickable()"
  [class.cb-icon-only]="iconOnly()"
  [style]="{ '--customColor': currentCustomColor }"
>
  @if (iconPosition() == "left") {
    <ng-container *ngTemplateOutlet="Icon"></ng-container>
  }

  <p>
    {{ currentLabel }}
  </p>
  @if (iconPosition() == "right") {
    <ng-container *ngTemplateOutlet="Icon"></ng-container>
  }
</div>

<ng-template #Icon>
  @switch (iconType()) {
    <!-- dot  -->
    @case ("dot") {
      <cb-dot
        [color]="
          dotColor === 'auto' || color() === 'custom' ? 'custom' : dotColor
        "
        [customColor]="
          color() === 'auto' || color() === 'custom'
            ? currentCustomColor
            : undefined
        "
        size="sm"
      ></cb-dot>
    }
    <!-- avatar -->
    @case ("avatar") {}
    <!-- x-close -->
    @case ("x-close") {
      <div class="cb-chip-close">
        <cb-icon
          name="cb-base-outline-close"
          (click)="closeChipClick($event)"
        ></cb-icon>
      </div>
    }
    <!-- icon -->
    @case ("icon") {
      @if (icon()) {
        <cb-icon [name]="icon()!"></cb-icon>
      }
    }
  }
</ng-template>
